import { useContext, useEffect, useState } from 'react'
import { OrderFormContext } from '../contexts'

const useCalculateTotalAmount = () => {
  const [totalAmount, setTotalAmount] = useState(0)

  const {
    images
  } = useContext(OrderFormContext)

  useEffect(() => {
    const _calculateTotalAmount = () => {
      let totalImageAmount = 0
      if (images.length > 0) {
        images.forEach(({ amount }) => {
          totalImageAmount += amount
        })
      }

      setTotalAmount(totalImageAmount)
    }

    _calculateTotalAmount()
  }, [images])

  return totalAmount
}

export default useCalculateTotalAmount
